import React from "react";

// Geometric motifs echoing the Elenem Strategies logo:
// - Striped tan triangle
// - Cobalt triangle
// - Warm orange quarter-circle arc

export const StripedTriangle = ({ className = "", size = 220, flip = false }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 100 100"
    aria-hidden="true"
  >
    <defs>
      <pattern id="strp" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
        <line x1="0" y1="0" x2="0" y2="8" stroke="#D7CFC0" strokeWidth="4" />
      </pattern>
    </defs>
    <polygon
      points={flip ? "0,0 100,0 100,100" : "0,0 100,0 0,100"}
      fill="url(#strp)"
    />
  </svg>
);

export const CobaltTriangle = ({ className = "", size = 200, flip = false }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
    <polygon
      points={flip ? "0,100 100,0 100,100" : "0,0 100,0 100,100"}
      fill="#1D4ED8"
    />
  </svg>
);

export const OrangeArc = ({ className = "", size = 180 }) => {
  const gid = `oa-lines-${Math.round(size)}`;
  return (
    <svg className={className} width={size} height={size * 0.5} viewBox="0 0 100 50" aria-hidden="true">
      <defs>
        <pattern id={gid} width="6" height="6" patternUnits="userSpaceOnUse">
          <line x1="0" y1="0" x2="0" y2="6" stroke="#FFE1CC" strokeWidth="2" />
        </pattern>
      </defs>
      {/* Solid orange base semi-circle (flat edge on bottom) */}
      <path d="M0,50 A50,50 0 0 1 100,50 Z" fill="#EA580C" />
      {/* Subtle vertical line hatching for texture */}
      <path d="M0,50 A50,50 0 0 1 100,50 Z" fill={`url(#${gid})`} opacity="0.55" />
    </svg>
  );
};

// A composed decorative arrangement used on hero + collaborate page
export const LogoMotifArrangement = ({ className = "" }) => (
  <div className={`relative ${className}`} aria-hidden="true">
    <StripedTriangle className="absolute top-0 left-0" size={260} />
    <CobaltTriangle className="absolute bottom-0 right-0" size={240} flip />
    <OrangeArc className="absolute bottom-0 left-1/3" size={160} />
  </div>
);
